import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';

// Pages
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import OrdersManagement from './pages/OrdersManagement';
import MenuManagement from './pages/MenuManagement';
import InventoryManagement from './pages/InventoryManagement';
import TablesManagement from './pages/TablesManagement';
import CustomerManagement from './pages/CustomerManagement';
import FinancialManagement from './pages/FinancialManagement';
import PromotionsManagement from './pages/PromotionsManagement';
import Reports from './pages/Reports';
import StaffManagement from './pages/StaffManagement';
import Settings from './pages/Settings';
import SalesData from './pages/SalesData';
import WaiterOrdering from './pages/WaiterOrdering';
import CounterBilling from './pages/CounterBilling';
import KitchenDisplay from './pages/KitchenDisplay';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/orders" element={<OrdersManagement />} />
          <Route path="/admin/menu" element={<MenuManagement />} />
          <Route path="/admin/inventory" element={<InventoryManagement />} />
          <Route path="/admin/tables" element={<TablesManagement />} />
          <Route path="/admin/customers" element={<CustomerManagement />} />
          <Route path="/admin/financial" element={<FinancialManagement />} />
          <Route path="/admin/promotions" element={<PromotionsManagement />} />
          <Route path="/admin/reports" element={<Reports />} />
          <Route path="/admin/staff" element={<StaffManagement />} />
          <Route path="/admin/settings" element={<Settings />} />
          <Route path="/admin/sales" element={<SalesData />} />
          <Route path="/waiter/ordering" element={<WaiterOrdering />} />
          <Route path="/counter/billing" element={<CounterBilling />} />
          <Route path="/kitchen/display" element={<KitchenDisplay />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
